export const globalSignalingConns = new Map();
export const globalRooms = new Map();
export function announceSignalingInfo(room) {
    globalSignalingConns.forEach((conn) => {
        // only subcribe if connection is established, otherwise the conn automatically subscribes to all rooms
        if (conn.connected) {
            conn.send({ type: "subscribe", topics: [room.name] });
            if (room.webrtcConns.size < room.provider.maxConns) {
                conn.publishSignalingMessage(room, {
                    type: "announce",
                    from: room.peerId,
                });
            }
        }
    });
}
//# sourceMappingURL=globalResources.js.map